import { render } from "./ManufacturerInfo.vue?vue&type=template&id=18c35941"
import script from "./ManufacturerInfo.vue?vue&type=script&lang=js"
export * from "./ManufacturerInfo.vue?vue&type=script&lang=js"

import "./ManufacturerInfo.vue?vue&type=style&index=0&id=18c35941&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__